import type { ShipmentStatus } from "../api/types.ts"
import type { StepState } from "./case-steps.ts"

export type ShipmentStep = { id: string; state: StepState }

/** 선적 상태 머신의 본줄기. */
const FLOW = ["draft", "shipped", "osaka_arrived", "sailed", "delivered"] as const

export function shipmentSteps(status: ShipmentStatus): ShipmentStep[] {
  const at = FLOW.indexOf(status)
  const current = at === -1 ? 0 : at
  const isLast = current === FLOW.length - 1
  return FLOW.map((id, index) => ({
    id,
    state:
      index < current || (isLast && index === current)
        ? "done"
        : index === current
          ? "current"
          : "todo",
  }))
}
